module.exports = __webpack_public_path__ + "img/veloshop.ca_Quebec__1551459849_76.67.188.141.2fa579d5.jpg";